import { useWSModalCustom, WSModal } from "@wingspanhq/fe-component-library";
import { ResourceHistory } from "../../../../shared/components/ResourceHistory";
import { useMemo } from "react";
import { WSModalCustomProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSModal/useWSModalCustom.hook";

const useEngagementTypeHistoryResources = (engagementTypeId: string) => {
  return useMemo(
    () => [
      {
        resourceType: "Engagement",
        resourceId: engagementTypeId
      }
    ],
    [engagementTypeId]
  );
};

type ModalProps = WSModalCustomProps<void> & {
  engagementTypeId: string;
};

export const ModalEngagementTypeHistory: React.FC<ModalProps> = ({
  engagementTypeId,
  ...modalProps
}) => {
  const scope = useEngagementTypeHistoryResources(engagementTypeId);

  return (
    <WSModal title="Engagement history" {...modalProps}>
      <ResourceHistory resources={scope} />
    </WSModal>
  );
};

export const EngagementTypeHistoryWidget: React.FC<{
  engagementTypeId: string;
}> = ({ engagementTypeId }) => {
  const modal = useWSModalCustom(ModalEngagementTypeHistory);
  const scope = useEngagementTypeHistoryResources(engagementTypeId);

  return (
    <ResourceHistory
      resources={scope}
      onViewAll={() => {
        modal.open({ engagementTypeId });
      }}
    />
  );
};
